export const NOM_ANI = 'NOM_ANI';
export const TYPE_ANI = 'TYPE_ANI';
export const RACE_ANI = 'RACE_ANI';
export const DATENAISS_ANI = 'DATENAISS_ANI';
export const SEX_ANI = 'SEX_ANI';
export const PUC_ANI = 'PUC_ANI';
export const ID_ANI = 'ID_ANI';
export const VAC_ANI = 'VAC_ANI';
export const ANT_ANI = 'ANT_ANI';
export const MAL_ANI = 'MAL_ANI';
export const REM_TYPE = 'REM_TYPE';
